// extracted by mini-css-extract-plugin
module.exports = {"row":"detail_row__NxqR1","label":"detail_label__28r1p"};